import React from "react";
import { faBookmark as faBookmarkRegular } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { AnalyticsSearchOptions } from "../../pages/Analytics/analytics";
import { useSearchParams } from "react-router-dom";
import { 
  createChartData, 
  getAllAnalyticChartData,
  selectChartData 
} from "../../reducers/analyticsSlice";
import { useToaster } from "../hooks/useToaster";
import { ExtendedAnalyticsSearchOptions } from "./filterModalDropdown";
import { useAppDispatch, useAppSelector } from "../../reducers/store";

export interface DaisyModalProps {
  title: string;
  content: string;
  searchOptions: AnalyticsSearchOptions;
}

export default function filterDropdown(props: DaisyModalProps) {
  const dispatch = useAppDispatch();
  const chartData = useAppSelector(selectChartData);
  const [searchParams] = useSearchParams();
  const [paramsObject, setParamsObject] = useState(
    {} as AnalyticsSearchOptions,
  );
  const [filterExists, setFilterExists] = useState(false);

  const [toasterState, openToaster, closeToaster] = useToaster();

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");

  const handleTitleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTitle(event.target.value);
  };

  const handleDescriptionChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setDescription(event.target.value);
  };

  useEffect(() => {
    // Function to retrieve all search parameters and convert them into an object
    const getAllSearchParams = () => {
      const paramsObject = {} as AnalyticsSearchOptions;
      // Loop through all search parameters and add them to the object
      searchParams.forEach((value, key) => {
        paramsObject[key as keyof AnalyticsSearchOptions] = value;
      });
      return paramsObject;
    };

    //  all params is the object that contains all the search parameters
    const allParams = getAllSearchParams();

    setParamsObject(allParams);
    GetAllData();
  }, [searchParams]);

  const GetAllData = async () => {
    setTimeout(async () => {
      await dispatch(getAllAnalyticChartData());
    }, 100);
  };

  const checkForDupe = (title: string, description: string) => {
    let doesFilterAlreadyExist = false;

    for(let filter of chartData){
      if(filter.calculation == props.searchOptions.calculation && 
        filter.chartType == props.searchOptions.chartType && 
        filter.customEndDate == props.searchOptions.customEndDate && 
        filter.customStartDate == props.searchOptions.customStartDate && 
        filter.group == props.searchOptions.group && 
        filter.timeIncrement == props.searchOptions.timeIncrement && 
        filter.timePeriod == props.searchOptions.timePeriod && 
        filter.type == props.searchOptions.type 
      ){
        doesFilterAlreadyExist = true;
      }
    }

    if(!doesFilterAlreadyExist){
      saveForLater(title, description);
    }
    setFilterExists(doesFilterAlreadyExist);
  }

  async function saveForLater(title: string, description: string) {
    try {
      await dispatch(createChartData({
        name: title,
        description,
        ...props.searchOptions,
      } as ExtendedAnalyticsSearchOptions));
      
      const modal = document.getElementById("my_modal_1") as HTMLDialogElement;
      if (modal) {
        openToaster("Filter saved successfully", "medium", "success");
        GetAllData();
        modal.close();
      }
      setFilterExists(false);
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div>
      {/* Open the modal using document.getElementById('ID').showModal() method */}
      <button
        className="flex h-[36px] w-[140px] items-center justify-evenly gap-x-[8px] rounded-md border border-gray-300 bg-white px-[12px] shadow-lg"
        style={{
          border: "1px solid transparent", // Transparent border to help with the visual effect
          boxShadow: "0 0 5px rgba(0, 0, 0, 0.3)", // Blurred border effect
          backdropFilter: "blur(1px)", // Slightly reduced blur effect
          backgroundColor: "rgba(255, 255, 255, 0.1)", // Semi-transparent background
        }}
        onClick={() =>
          (
            document.getElementById("my_modal_1") as HTMLDialogElement
          )?.showModal()
        }
      >
        <FontAwesomeIcon
          className="text-[14px] text-[#212322]"
          icon={faBookmarkRegular}
        />
        <span className="text-[14px]">Save for later</span>
      </button>
      <dialog id="my_modal_1" className="modal">
        {!filterExists && 
          <div className="modal-box rounded-md bg-white">
            <h3 className="mb-3 text-xl font-bold">{props.title}</h3>
            <div className="absolute -mx-6 mb-5 w-full border-t"></div>{" "}
            <h1 className="mb-2 mt-10 text-sm font-bold">Title</h1>
            <input
              className="mb-4 h-[40px] w-full rounded-md border bg-white p-2"
              type="text"
              name=""
              id=""
              placeholder="Enter your title here..."
              value={title}
              onChange={handleTitleChange}
            />
            <h1 className="mb-2 text-sm font-bold">Description</h1>
            <textarea
              className="h-32 w-full resize-none rounded-md border bg-white p-2"
              name=""
              id=""
              value={description}
              onChange={handleDescriptionChange}
              placeholder="Enter your description here..."
            ></textarea>
            <div className="absolute -mx-6 mb-5 mt-10 w-full border-t"></div>{" "}
            <div className="modal-action mt-20">
              <form method="dialog">
                <button onClick={() => setFilterExists(false)} className="border-md btn border-none border-gray-300 bg-gray-300 text-tqsBlack hover:border-none hover:bg-gray-300">
                  Cancel
                </button>
              </form>

              <button
                onClick={() => checkForDupe(title, description)}
                className="btn border-none bg-tqsYellow text-tqsBlack hover:bg-tqsYellow"
              >
                Save
              </button>
            </div>
          </div>
        }

        {filterExists && 
          <div className="modal-box rounded-md bg-white">
            <h3 className="mb-3 text-xl font-bold">{props.title}</h3>
            <div className="absolute -mx-6 mb-5 w-full border-t"></div>{" "}
            <p className="pt-[20px] text-sm font-bold">There has already been a report created with these settings, are you sure you would like to save this? </p>
            <div className="absolute -mx-6 mb-5 mt-10 w-full border-t"></div>{" "}
            <div className="modal-action mt-20">
              <form method="dialog">
                <button onClick={() => setFilterExists(false)} className="border-md btn border-none border-gray-300 bg-gray-300 text-tqsBlack hover:border-none hover:bg-gray-300">
                  Cancel
                </button>
              </form>

              <button
                onClick={() => saveForLater(title, description)}
                className="btn border-none bg-tqsYellow text-tqsBlack hover:bg-tqsYellow"
              >
                Confirm
              </button>
            </div>
          </div>
        }

      </dialog>
    </div>
  );
}
